/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseOwnerResponsePartnerInformation
 */
export interface CaseOwnerResponsePartnerInformation {
    /**
     * 
     * @type {string}
     * @memberof CaseOwnerResponsePartnerInformation
     */
    partnerUid?: string;
}

/**
 * Check if a given object implements the CaseOwnerResponsePartnerInformation interface.
 */
export function instanceOfCaseOwnerResponsePartnerInformation(value: object): value is CaseOwnerResponsePartnerInformation {
    return true;
}

export function CaseOwnerResponsePartnerInformationFromJSON(json: any): CaseOwnerResponsePartnerInformation {
    return CaseOwnerResponsePartnerInformationFromJSONTyped(json, false);
}

export function CaseOwnerResponsePartnerInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseOwnerResponsePartnerInformation {
    if (json == null) {
        return json;
    }
    return {
        
        'partnerUid': json['partnerUid'] == null ? undefined : json['partnerUid'],
    };
}

export function CaseOwnerResponsePartnerInformationToJSON(json: any): CaseOwnerResponsePartnerInformation {
    return CaseOwnerResponsePartnerInformationToJSONTyped(json, false);
}

export function CaseOwnerResponsePartnerInformationToJSONTyped(value?: CaseOwnerResponsePartnerInformation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partnerUid': value['partnerUid'],
    };
}

